import { SearchOutlined } from '@ant-design/icons';
import { TermFilter } from '@dofleini/query-builder';
import { Checkbox, Form, Input } from 'antd';
import classNames from 'classnames';
import find from 'lodash/find';
import compose from 'lodash/fp/compose';
import filterFP from 'lodash/fp/filter';
import mapFP from 'lodash/fp/map';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';

import findMatch from '@/utils/findMatch';

import FilterContent from '../../FilterContent';

export const EnumComponent = ({ filter, t, applyFilter, currentValue }) => {
  const [searchText, setSearchText] = useState('');
  
  const options = useMemo(() => filter.options || [], [filter.options]);
  
  const filteredOptions = useMemo(() => compose(
    filterFP(({ label }) => findMatch(searchText, label)),
    mapFP(({ label, ...rest }) => ({ label: t(label), ...rest })),
  )(options), [options, searchText, t]);
  
  const onFinish = useCallback(({ value: values }) => {
    if (values && !isEmpty(values)) {
      
      let filterOptions = map(values, value => {
        if (!Array.isArray(filter.field)) {
          return new TermFilter({
            field: filter.field,
            value: value === -1 ? null : value
          }).toQuery();
        } else {
          return {
            'type': 'OR',
            'filters': filter.field?.map((e) => new TermFilter({
              field: e,
              value: value === -1 ? null : value
            }).toQuery())
          };
        }
      });
      
      applyFilter(
        {
          'type': 'OR',
          'filters': filterOptions
        }
      );
    } else {
      applyFilter();
    }
  }, [applyFilter, filter.field]);
  
  return (<>
    {
      filter.search &&
      <div className="p-2">
        <Input suffix={<SearchOutlined/>} value={searchText} onChange={({ target }) => setSearchText(target?.value)}/>
      </div>
    }
    
    <Form onFinish={onFinish}>
      <FilterContent t={t}>
        <Form.Item name="value" className="m-0" initialValue={currentValue || []}>
          <Checkbox.Group className="w-full">
            <div className="w-full flex flex-col max-w-300px max-h-300px overflow-y-auto">
              {
                filteredOptions.map(({ value, label }) => (
                  <Checkbox className={classNames('mx-0 my-px p-2')} key={value} value={value}>
                    {label}
                  </Checkbox>
                ))
              }
            </div>
          </Checkbox.Group>
        </Form.Item>
      </FilterContent>
    </Form>
  </>);
};

EnumComponent.propTypes = {
  filter: PropTypes.object,
  currentValue: PropTypes.array,
  t: PropTypes.func,
  applyFilter: PropTypes.func,
};

export const ValueEnum = ({ filterValue, t, filter }) => {
  const options = useMemo(() => map(
    filterValue?.filters,
    ({ value }) => {
      const item = find(filter?.options, { value });
      return t(item?.label);
    }).join(', '), [filter, t, filterValue]);
  
  return <p className="m-0 break-world leading-snug whitespace-pre-wrap">{options}</p>;
};

ValueEnum.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  filterValue: PropTypes.any,
};
